import React from "react";
import { Link } from "react-router-dom";

const VARIANTS = {
  primary: "bg-royal text-white hover:bg-[#1A44C2]",
  ghost: "border border-white text-white hover:bg-white hover:text-navy",
  paper: "bg-paper text-navy hover:bg-white",
  navy: "bg-navy text-white hover:bg-ink",
};

const SIZES = {
  md: "px-7 py-3.5 text-[15px]",
  sm: "px-5 py-2 text-[13.5px]",
};

const BASE =
  "group inline-flex items-center gap-2 rounded-sm font-hanken font-semibold transition-colors duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-royal focus-visible:outline-offset-2";

// One button, four treatments. Renders Link / a / button depending on props.
export default function HRButton({
  to,
  href,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  arrow = false,
  className = "",
  children,
  ...rest
}) {
  const cls = `${BASE} ${SIZES[size] || SIZES.md} ${VARIANTS[variant] || VARIANTS.primary} ${className}`;
  const content = (
    <>
      {children}
      {arrow && (
        <span
          aria-hidden="true"
          className="inline-block transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-1"
        >
          →
        </span>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={cls} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} onClick={onClick} className={cls} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls} {...rest}>
      {content}
    </button>
  );
}
